




























































































































































import Translations from "@/models/translations.model";
import ProductTileLayout from "./ProductTileLayout.vue";
import Icon from "@/models/icon.model";
import Award from "@/models/award.model";
import Product from "@/models/product.model";
import Config, { Mode, ButtonType } from "@/models/config.model";
import PromotionMaterial from "@/models/promotion-material.model";

export default {
  name: "ProductTile",
  components: {
    ProductTileLayout,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    productListingInstance: {
      type: Object,
      required: true,
    },
    productTileClass: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      instance: null,
      compareCheckboxHidden: true,
      compareCheckboxState: false,
      wishlistButtonState: false,
      detailLinktext: this.$store.state.translations.details,
      iframeRental: null,
      productAwards: null,
      isRentable: false,
      buttonType: this.$store.state.translations.buttonType,
      isPromotion: false,
      promotionMaterials: this.$store.state.promotionMaterials,
      promotionMaterial: {
        promoID: "",
        icon: "none",
        image: "none",
        label: "",
      },
    };
  },
  computed: {
    config(): Config {
      return this.$store.state.config;
    },
    isMatnoMode(): boolean {
      return this.config.mode === Mode.Matno;
    },
    isMatnoReducedMode(): boolean {
      return this.config.mode === Mode.MatnoReduced;
    },
    isFilterMode(): boolean {
      return this.config.mode === Mode.Filter;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
    ecoIcon(): Icon | null {
      const { product }: { product: Product } = this;

      if (!product.icon || !product.icon.length) {
        return null;
      }

      for (let i = 0, iLen = product.icon.length; i < iLen; i++) {
        const currentIcon = product.icon[i];

        if (currentIcon.type === "eco") {
          return currentIcon;
        }
      }

      return null;
    },
    awards(): Award[] | null {
      const { product }: { product: Product } = this;

      if (!product.awards || product.awards.length === 0) {
        return null;
      }

      return product.awards;
    },
    detailLink(): string {
      const productName = this.product.label
        .replace(/[\[\]().,]/g, "") // remove square brackets, parantheses, dots and commas
        .replace(/\+/g, "") // remove plus char
        .replace(/[\s–/]/g, "-") // replace spaces, dashes and slashes with hyphens
        .replace(/-{2,}/g, "-") // replace multiple hyphens with a single hyphen
        .replace(/®|©/g, "") // replace Trademark and Copyright symbol
        .toLowerCase();

      return this.createDetailLink(productName);
    },
    promotionMaterialsLink() {
      if (this.promotionMaterial.icon != "none") {
        let svg = `<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wmedia/pwp/1.37.0/svg/crd-product-tile.svg#${this.promotionMaterial.icon}"></use></svg>`;

        return `<a href="${this.promotionMaterial.promoID}" class="mouseover" aria-expanded="false" rel="nofollow">
          ${svg}${this.promotionMaterial.label}
          </a>`;
      } else if (
        this.promotionMaterial.icon === "none" &&
        this.promotionMaterial.image != "none"
      ) {
        let image = `<img class="promotion-gift__image" src="${this.promotionMaterial.image}" height="24">`;

        return `<a href="${this.promotionMaterial.promoID}" class="mouseover" aria-expanded="false" rel="nofollow">
          ${image}${this.promotionMaterial.label}
          </a>`;
      } else {
        return `<a href="${this.promotionMaterial.promoID}" class="mouseover" aria-expanded="false" rel="nofollow">
          ${this.promotionMaterial.label}
          </a>`;
      }
    },
  },
  methods: {
    init(): void {
      this.instance = new this.productTileClass(this);
      this.iframeRental = document.getElementById(
        "offcanvasIframeRental"
      ) as any;
      this.productAwards = document.querySelector(
        ".crd-product-tile__awards-items"
      ) as HTMLElement;

      if (this.iframeRental) {
        setTimeout(() => {
          const rentalLinks = document.querySelectorAll(
            `.offcanvasIframeElementTrigger-${this.product.matNo}`
          );

          rentalLinks.forEach((el) => {
            if (!this.iframeRental.instance) {
              this.initOffCanvas(this.iframeRental);
            }

            el.addEventListener("click", (e) => {
              if (this.isRentable) {
                e.preventDefault();

                this.iframeRental.instance.setIframeSrc(this.detailLink);
                this.iframeRental.instance.setVisibility(true);
              }
            });
          });
        }, 10);
      }

      if (this.promotionMaterials && this.promotionMaterials.length > 0) {
        this.promotionMaterials.forEach((promotion: PromotionMaterial) => {
          const matnosArray = promotion.matnos.split(",");

          if (matnosArray.includes(this.product.matNo)) {
            this.promotionMaterial.promoID = `#${promotion.promoID}`;
            this.isPromotion = true;
            this.promotionMaterial.icon = promotion.icon;
            this.promotionMaterial.image = promotion.image;
            this.promotionMaterial.label = promotion.label;
            this.instance.createTooltips(this.$el);
          }
        });
      }

      if (this.productAwards) {
        this.initProductEwards(this.productAwards);
      }
    },
    toggleWishlist(): void {
      this.instance.toggleWishlistButtonState();
    },
    toggleCompare(e: Event): void {
      const checkbox = e.currentTarget as HTMLInputElement;
      this.instance.toggleCompare(checkbox.checked);
    },
    setWishlistButtonState(wishlistButtonState: boolean): void {
      this.wishlistButtonState = wishlistButtonState;
    },
    setCompareCheckboxState(compareCheckboxState: boolean): void {
      this.compareCheckboxState = compareCheckboxState;
    },
    setCompareCheckboxHidden(compareCheckboxHidden: boolean): void {
      this.compareCheckboxHidden = compareCheckboxHidden;
    },
    createDetailLink(productName: string): string {
      const rentalLink = this.createRentalLink();

      if (rentalLink !== "") {
        return rentalLink;
      }

      const materials = this.$store.state.productsShop;

      if (
        materials &&
        !this.isFilterMode &&
        this.buttonType === ButtonType.Shop
      ) {
        const material = materials.filter(
          (material: { matNo: any }) => material.matNo === this.product.matNo
        );

        if (material.length === 0) {
          return this.translations.detailLink
            .replace("{MAT}", this.product.matNo)
            .replace("{NAME}", productName);
        }

        this.detailLinktext = this.$store.state.translations.shop;

        return this.translations.shopLink.replace(/{MAT}/g, material[0].matNo);
      }

      return this.translations.detailLink
        .replace("{MAT}", this.product.matNo)
        .replace("{NAME}", productName);
    },
    createRentalLink(): string {
      const materialsRental = this.$store.state.productsRental;

      if (
        materialsRental &&
        !this.isFilterMode &&
        this.$store.state.translations.rentalLink !== "" &&
        this.buttonType === ButtonType.Rental
      ) {
        const materialRental = materialsRental.filter(
          (material: { matNo: any }) => material.matNo === this.product.matNo
        );

        if (materialRental.length === 0) {
          return "";
        }

        this.isRentable = true;
        this.detailLinktext = this.$store.state.translations.rental;

        return this.$store.state.translations.rentalLink.replace(
          /{MAT}/g,
          materialRental[0].matNo
        );
      } else {
        return "";
      }
    },
    initOffCanvas(el: any) {
      Miele.ModuleLoader.createModuleInstance(
        "elements/objects/offcanvas-rental",
        el
      );
    },
    initProductEwards(el: HTMLElement) {
      Miele.ModuleLoader.createModuleInstance("elements/product/technical", el);
    },
    awardLink(src: string): string {
      let awardLink = src.split("?").shift();
      awardLink += "?d=200&impolicy=p-resize-w";
      return awardLink || "";
    },
  },
  mounted() {
    this.init();
  },
};
